import styled from 'styled-components';

const Link = styled.a`
  color: #6200ff;
  text-decoration: none;
  cursor: pointer;
`;

export default Link;
